import "jquery";
import * as ko from "knockout";
import { DeliveryGroupedByCropNumber } from "../Models/Crops/DeliveryGroupedByCropNumber";
import {BaseCropComponent} from "./BaseCropComponent";

export class Deliveries extends BaseCropComponent<DeliveryGroupedByCropNumber> {
    constructor() {
        super($('#deliveries-table'));
    }
    init(): void {
        this.cropsApi.getDeliveries().then((res) => {
          super.init(res, "cropNo", '*[data-bind="text: deliveryCrop.CropNumber"]');
      });
    }
}